export default function quoteCreateInv(data) {
  const params = { action: "quote_create_invoice", record: data.id };

  this.load();
  this.rest.post("customAction", params, (resp) => {
    if (resp.errCode == "OK") {
      this.href("#detail/acm_invoices/" + resp.record);
    } else {
      this.unLoad();
      this.alert(resp.errMsg);
    }
  });

}